import { createSelector } from 'reselect';
import { Selectors, State } from '@grandvisionhq/auth';
import { idleState, uninitState } from '@grandvisionhq/state';
import { getMyAccount } from '../selectors.js';

const getCCCSubscriptions = createSelector(getMyAccount, Selectors.getAuth, (myAccount, auth)=>State.isLoggedIn(auth) ? myAccount.ccc : undefined
);
const getCCCSubscriptionDetail = createSelector(getCCCSubscriptions, (subscription)=>subscription ? subscription.detail : undefined
);
const getCCCForm = createSelector(getCCCSubscriptions, (subscription)=>{
    return subscription === null || subscription === void 0 ? void 0 : subscription.cccForm;
});
const getCCCSubscriptionDetailCall = createSelector(getCCCSubscriptions, (subscription)=>subscription ? subscription.detailCall : idleState()
);
const getPauseCall = createSelector(getCCCSubscriptions, (subscription)=>subscription ? subscription.pauseCall : idleState()
);
const getQuantityCall = createSelector(getCCCSubscriptions, (subscription)=>subscription ? subscription.quantityCall : idleState()
);
const getProductDataCall = createSelector(getCCCSubscriptions, (subscription)=>subscription ? subscription.productDataCall : idleState()
);
const getProductData = createSelector(getCCCSubscriptions, (subscription)=>subscription ? subscription.productData : {}
);
const getCCCSubscriptionList = createSelector(getCCCSubscriptions, (subscriptions)=>subscriptions ? subscriptions.list : uninitState()
);

export { getCCCForm, getCCCSubscriptionDetail, getCCCSubscriptionDetailCall, getCCCSubscriptionList, getCCCSubscriptions, getPauseCall, getProductData, getProductDataCall, getQuantityCall };
//# sourceMappingURL=selectors.js.map
